// The startup milestones (design 11 §3), as performance marks the budget check reads
// (client/scripts/budget.mjs): the board's first render, the own hand's first pictures, and every tile on
// the table drawn; the signed-out page's words and Play now (design 14 §9.1). Each is marked once per page load.
import { createSignal } from "solid-js";

const seen = new Set<string>();
const [drawn, setDrawn] = createSignal(false);

/** Whether a table's every tile has been drawn on this page load: what waits for the first visit's tiles (Table's display face). */
export const tilesDrawn = drawn;

export type Milestone = "mj:board" | "mj:hand" | "mj:tiles" | "mj:landing";

export function milestone(name: Milestone): void {
  if (name === "mj:tiles") setDrawn(true);
  if (seen.has(name) || typeof performance === "undefined") return;
  seen.add(name);
  performance.mark(name);
}
